import { render, staticRenderFns } from "./LongueursVente.vue?vue&type=template&id=235d0e41&"
import script from "./LongueursVente.vue?vue&type=script&lang=ts&"
export * from "./LongueursVente.vue?vue&type=script&lang=ts&"
import style0 from "./LongueursVente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports